import { scrollToPosition } from './smoothScrollToAnchor';
import { initCalendarMobileToggle } from './calendarMobileToggle';
import { collapsibleSection } from './collapsibleSection';

export const showPage = function() {
	const collapsedSection = document.querySelector('.show-details__text');

	const searchParam = window.location.search;
	if (searchParam.includes('cast-and-creative')) {
		document.getElementById('cast-and-creative').click();
	}

	if (collapsedSection) {
		collapsibleSection(collapsedSection);
	}

	const subNavLinks = document.querySelectorAll('.show-subnav__link');
	const sections = document.querySelectorAll('#show-info, #cast-and-creative, #faqs, #related-news, #calendar-toggle-container, #site-access-performances');

	if (!subNavLinks && !sections) {
		return;
	}

	const openAccordionIfClosed = (accordionId) => {
		const accordionToggles = document.querySelectorAll('.show-accordion__toggle');

		for (let i = 0; i < accordionToggles.length; i++) {
			const button = accordionToggles[ i ];
			const controlsId = button.getAttribute('aria-controls');
			const section = document.getElementById(controlsId);

			if (section && section.closest(accordionId) !== null) {
				const isExpanded = button.getAttribute('aria-expanded') === 'true';
				if (!isExpanded) {
					button.click();
				}
				return;
			}

			if (button.closest(accordionId) !== null) {
				const isExpanded = button.getAttribute('aria-expanded') === 'true';
				if (!isExpanded) {
					button.click();
				}
				return;
			}
		}

		if (accordionId.startsWith('#')) {
			const accordionContent = document.querySelector(accordionId);
			if (accordionContent) {
				for (let i = 0; i < accordionToggles.length; i++) {
					const button = accordionToggles[ i ];
					const controlsId = button.getAttribute('aria-controls');

					if (controlsId === accordionId.substring(1) || controlsId === accordionId) {
						const isExpanded = button.getAttribute('aria-expanded') === 'true';
						if (!isExpanded) {
							button.click();
						}
						return;
					}
				}
			}
		}
	};

	subNavLinks.forEach((link) => {
		link.addEventListener('click', function(e) {
			e.preventDefault();

			const href = e.currentTarget && e.currentTarget.getAttribute('href');
			const hash = href && href.includes('#') ? href.substring(href.indexOf('#')) : null;

			if (!hash) {
				return;
			}

			const targetElement = document.querySelector(hash);

			if (targetElement) {
				openAccordionIfClosed(hash);

				setTimeout(() => {
					const headerHeight = document.querySelector('.show-subnav-container') && document.querySelector('.show-subnav-container').offsetHeight || 0;
					const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;

					scrollToPosition(targetPosition);
					setActiveNavItem();

					history.pushState(null, null, hash);
				}, 50);
			}
		});
	});

	const setActiveNavItem = () => {
		const scrollPosition = window.pageYOffset;
		const headerHeight = document.querySelector('.show-subnav-container') && document.querySelector('.show-subnav-container').offsetHeight || 0;
		let closestSection = null;
		let closestOffset = Infinity;

		sections.forEach((section) => {
			if (!section) {
				return;
			}

			const sectionTop = section.offsetTop - headerHeight;
			const distance = Math.abs(scrollPosition - sectionTop);

			if (scrollPosition >= sectionTop && distance < closestOffset) {
				closestOffset = distance;
				closestSection = section;
			}
		});

		subNavLinks.forEach((link) => {
			if (!link) {
				return;
			}

			link.classList.remove('active-section');

			const href = link.getAttribute('href');
			let linkHash = null;

			try {
				const url = new URL(href, window.location.origin);
				linkHash = url.hash;
			} catch (err) {
				linkHash = href && href.startsWith('#') ? href : null;
			}

			if (closestSection && linkHash === `#${ closestSection.id }`) {
				link.classList.add('active-section');
			}
		});
	};

	const subNav = document.querySelector('.show-subnav-container');

	if (subNav) {
		window.addEventListener('scroll', function() {
			setActiveNavItem();
		});
	}

	// Check if there is a hash in the URL on page load.
	if (window.location.hash) {
		const targetElement = document.querySelector(window.location.hash);
		if (targetElement) {
			openAccordionIfClosed(window.location.hash);

			setTimeout(function() {
				const headerHeight = document.querySelector('.show-subnav-container').offsetHeight || 0;
				const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;

				scrollToPosition(targetPosition);
			}, 100);
		}
	}

	const startCalendarMobileToggleWhenReady = () => {
		const mount = document.getElementById('calendar-toggle-container');
		const mini = document.querySelector('[farlo-ui="calendar-mini"], [farlo-ui="calendar-mini-alternative"]');

		if (mount && mini) {
			initCalendarMobileToggle();
		} else {
			requestAnimationFrame(startCalendarMobileToggleWhenReady);
		}
	};
	startCalendarMobileToggleWhenReady();

	// -------------------------------------------------------------------------
	// Lightbox
	// -------------------------------------------------------------------------

	const lightbox = document.getElementById('lightbox');
	if (!lightbox) {
		initDeferredImages();
		initShowGallery();
		return;
	}

	const closeBtn = document.querySelector('.lightbox__close');
	const activeImage = document.getElementById('lightbox__active-img');
	const activeVideo = document.getElementById('lightbox__video');
	const thumbnails = document.querySelectorAll('.lightbox__thumbnail');
	const overlay = document.querySelector('.lightbox__overlay');
	const lightboxTriggers = document.querySelectorAll('.lightbox__trigger');
	const prevBtn = document.querySelector('.lightbox__prev');
	const nextBtn = document.querySelector('.lightbox__next');

	let slides = [];
	let currentSlide = 0;

	function initialiseSlides() {
		slides = [];
		thumbnails.forEach((thumb) => {
			slides.push({
				type: thumb.dataset.type,
				src: thumb.dataset.src
			});
		});
	}

	// Show the active slide by index.
	function showSlide(index) {
		if (index < 0) {
			index = slides.length - 1;
		}
		if (index >= slides.length) {
			index = 0;
		}

		const slide = slides[ index ];

		if (slide.type === 'video') {
			activeImage.style.display = 'none';
			activeVideo.style.display = 'block';
			activeVideo.src = `${ slide.src }?autoplay=1&rel=0`;
		} else {
			activeVideo.src = '';
			activeVideo.style.display = 'none';
			activeImage.style.display = 'block';
			activeImage.src = slide.src;
		}

		thumbnails.forEach((thumb) => {
			thumb.classList.remove('active');
		});
		thumbnails[ index ].classList.add('active');
		thumbnails[ index ].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

		currentSlide = index;
	}

	// Open the lightbox at the first slide.
	lightboxTriggers.forEach((trigger) => {
		trigger.addEventListener('click', function(e) {
			e.preventDefault();
			initialiseSlides();
			lightbox.style.display = 'flex';
			showSlide(0);
		});
	});

	// Close the lightbox and stop any playing video.
	closeBtn.addEventListener('click', function() {
		lightbox.style.display = 'none';
		activeVideo.src = '';
	});

	overlay.addEventListener('click', function() {
		lightbox.style.display = 'none';
		activeVideo.src = '';
	});

	// Navigate between slides.
	prevBtn.addEventListener('click', function() {
		showSlide(currentSlide - 1);
	});

	nextBtn.addEventListener('click', function() {
		showSlide(currentSlide + 1);
	});

	thumbnails.forEach((thumb, index) => {
		thumb.addEventListener('click', function(e) {
			showSlide(index);
		});
	});

	// Close on Escape; navigate with arrow keys.
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape') {
			lightbox.style.display = 'none';
			activeVideo.src = '';
		} else if (e.key === 'ArrowLeft') {
			prevBtn.click();
		} else if (e.key === 'ArrowRight') {
			nextBtn.click();
		}
	});

	// Initialise deferred image loading and the gallery after the lightbox
	// setup, so all three components can coexist on the same page.
	initDeferredImages();
	initShowGallery();
};

/**
 * Observe all images marked with the `js-lazy-img` class and swap their
 * `data-src` / `data-srcset` attributes to `src` / `srcset` the moment they
 * enter the viewport.
 */
function initDeferredImages() {
	const images = document.querySelectorAll('img.js-lazy-img');

	if (!images.length) {
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				const img = entry.target;

				// Promote srcset first so the browser can pick the correct
				// source before the src triggers a fallback fetch.
				if (img.dataset.srcset) {
					img.srcset = img.dataset.srcset;
					img.removeAttribute('data-srcset');
				}

				if (img.dataset.sizes) {
					img.sizes = img.dataset.sizes;
					img.removeAttribute('data-sizes');
				}

				if (img.dataset.src) {
					img.src = img.dataset.src;
					img.removeAttribute('data-src');
				}

				img.classList.remove('js-lazy-img');
				observer.unobserve(img);
			});
		},
		{
			// Begin loading slightly before the image reaches the viewport so
			// there is no visible gap as the user scrolls.
			rootMargin: '200px 0px',
		}
	);

	images.forEach((img) => observer.observe(img));
}

/**
 * Initialise all show gallery blocks on the page.
 */
function initShowGallery() {
	const galleries = document.querySelectorAll('.show-gallery');

	if (!galleries.length) {
		return;
	}

	galleries.forEach((gallery) => {
		const toggle = gallery.querySelector('.site-accordion__toggle');
		const dialogId = gallery.dataset.galleryDialog;
		const dialog = dialogId ? document.getElementById(dialogId) : null;

		if (!toggle) {
			return;
		}

		// Track whether deferred images have already been loaded for this gallery,
		// to avoid re-querying the DOM on every subsequent accordion open.
		let imagesLoaded = false;

		/**
		 * Swap every deferred thumbnail's data-src attribute to src.
		 * Called once the first time the accordion is expanded.
		 */
		const loadDeferredImages = () => {
			if (imagesLoaded) {
				return;
			}

			imagesLoaded = true;

			gallery.querySelectorAll('img[data-src]').forEach((img) => {
				img.src = img.dataset.src;
				img.removeAttribute('data-src');
			});
		};

		const accordionObserver = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (
					mutation.attributeName === 'aria-expanded' &&
					toggle.getAttribute('aria-expanded') === 'true'
				) {
					loadDeferredImages();
				}
			});
		});

		accordionObserver.observe(toggle, {
			attributes: true,
			attributeFilter: [ 'aria-expanded' ],
		});

		// If the accordion is already open when the page loads (e.g. via a
		// URL hash), load the images immediately without waiting for a change.
		if (toggle.getAttribute('aria-expanded') === 'true') {
			loadDeferredImages();
		}

		// No dialog present; skip video interaction setup for this gallery.
		if (!dialog) {
			return;
		}

		const iframe = dialog.querySelector('.show-gallery__embed');

		const closeGalleryDialog = () => {
			dialog.close();

			if (iframe) {
				iframe.src = '';
				iframe.title = '';
			}
		};

		gallery.querySelectorAll('[data-gallery-trigger]').forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				const videoId = trigger.dataset.videoId;
				const videoTitle = trigger.dataset.videoTitle || '';

				if (!videoId || !iframe) {
					return;
				}

				iframe.title = videoTitle;

				iframe.src = `https://www.youtube.com/embed/${ encodeURIComponent(videoId) }?autoplay=1&rel=0`;

				dialog.showModal();
			});
		});

		gallery.querySelectorAll('[data-gallery-close]').forEach((closeButton) => {
			closeButton.addEventListener('click', closeGalleryDialog);
		});

		dialog.addEventListener('click', (e) => {
			if (e.target === dialog) {
				closeGalleryDialog();
			}
		});

		dialog.addEventListener('close', () => {
			if (iframe) {
				iframe.src = '';
				iframe.title = '';
			}
		});
	});
}